import {FC, useState, createContext, useContext} from 'react'
import {
    QueryState,
    QueryRequestContextProps,
    initialQueryRequest,
    WithChildren,
} from '../../../../../_metronic/helpers'

const DLMROIQueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const DLMROIQueryRequestProvider: FC<WithChildren> = ({children}) => {
    const [state, setState] = useState<QueryState>(initialQueryRequest.state)

    const updateState = (updates: Partial<QueryState>) => {
        const updatedState = {...state, ...updates} as QueryState
        setState(updatedState)
    } 

    return (
    <DLMROIQueryRequestContext.Provider value={{state, updateState}}>
        {children}
    </DLMROIQueryRequestContext.Provider>
    )
}

const useDLMROIQueryRequest = () => useContext(DLMROIQueryRequestContext)
export {DLMROIQueryRequestProvider, useDLMROIQueryRequest}
